import axios from "axios";
import { Message } from "element-ui";
import router from "../router";

/* 创建axios实例 */
const axiosService = axios.create({
  timeout: 10000 /* 设置超时时间为10s */
});

/* request拦截器 ==> 对请求参数进行处理 */
axiosService.interceptors.request.use(
  config => {
    if (config.method === "get") {
      if (config.params !== null && config.params !== undefined) {
        config.params = { ...config.params };
      }
      config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    } else {
      if (
        config.data !== null &&
        config.data !== undefined &&
        config.url !== "/file/importPicture" &&
        config.url !== "/file/importOffice"
      ) {
        // 上传文件的接口不需要拆分formData
        config.data = { ...config.data };
      }
      config.headers["Content-Type"] = "application/json;charset=UTF-8";
    }

    // 专为上传文件用的
    if (
      config.url === "/file/importPicture" ||
      config.url === "/file/importOffice"
    ) {
      config.headers["Content-Type"] = "multipart/form-data";
    }

    config.headers.token = localStorage.getItem("pc_user_token");
    return config;
  },
  error => {
    Message.error("请求错误");
    return Promise.reject(error);
  }
);

/* respone拦截器 ==> 对响应做处理 */
axiosService.interceptors.response.use(
  response => {
    if (response.data) {
      // 针对登录超时的情况单独处理
      if (response.data.code === 2001) {
        // 后台要统一超时登录的错误码
        // 超时后
        localStorage.removeItem("pc_user_token");
        Message.error(response.data.message);
        router.push({ path: "/login" });
      } else if (response.data.code !== 200) {
        Message.error(response.data.message);
      }
      return response.data;
    } else {
      Message.error("服务器错误");
    }
  },
  error => {
    const requestConfig = (error && error.config) || {};
    const responseData = error && error.response ? error.response.data : null;
    const timeout = error && error.code === "ECONNABORTED";
    const message =
      (responseData && responseData.message) ||
      (timeout ? "请求超时，请稍后重试" : "网络连接出错");

    /* 判断error的status代码，并将对应的信息告知用户 */
    if (!requestConfig.silentErrorMessage) {
      Message.error(message);
    }
    console.log("response error: " + error);

    if (requestConfig.preserveErrorResponse) {
      return Promise.resolve({
        code:
          responseData && typeof responseData.code !== "undefined"
            ? responseData.code
            : -1,
        data:
          responseData && typeof responseData.data !== "undefined"
            ? responseData.data
            : null,
        message,
        networkError: responseData === null,
        timeout
      });
    }
    // 维持现有大部分页面的行为，不把异常直接抛给所有旧调用点
    return undefined;
  }
);

/* 将写好的axios实例暴露出去 */
export default axiosService;
